import React, {
  useState,
  useRef,
  // useMemo,
} from 'react';
import CouponModalStyled from './CouponModalStyled';
import {
  // TextField,
  IconButton,
  Box,
  useTheme,
  Typography,
  // Button,
} from '@material-ui/core';
import DataTableNativeML from '@/components/DataTableNativeML';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'dva';
import DialogML from '@/components/DialogML';
import CloseIcon from '@material-ui/icons/Close';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import ButtonTip from '@/components/buttonTip/ButtonTip';
import ChooseCoupon from '../activity_equity/member_level/choose_coupon/ChooseCoupon';
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import { useIntl } from 'umi';

export default (props) => {
  const {
    // handleSubmit,
    control,
    // errors,
  } = useForm({});
  const tableRef = useRef();
  const intl = useIntl();
  const { formatMessage } = intl;

  const theme = useTheme();
  const dispatch = useDispatch();
  const {
    setCoupons,
    dialogStatus,
    setDialogStatus,
    // couponType,
    couponId,
    setModify,
    // editId,
    // coupons = [],
    setIsSave,
  } = props;

  // const { data: cpList, total } =
  //   useSelector((state) => state.cpList?.cpList) || {};
  // 点击设置 存储每条couopns 然后点击确认 将数据存到每条couopns

  const couponList =
    useSelector((state) => state.sceneMarketing?.couponsList) || [];
  // saveCouponsList

  const labelCom = (
    <Box>
      <Box display="flex" justifyContent="space-between">
        <Box display="flex" alignItems="center">
          <Typography variant="body1" className="coupon-dialog-title-style">
            优惠券列表
          </Typography>
        </Box>
        {dialogStatus && (
          <IconButton aria-label="close" onClick={() => onCloseDialog()}>
            <CloseIcon className="coupon-dialog-close-icon-style" />
          </IconButton>
        )}
      </Box>
    </Box>
  );

  // const [pageData, setPageData] = useState({
  //   pageSize: 10,
  //   pageNum: 1,
  // });

  // const [title, setTitle] = useState();
  const [couponOpen, setCouponOpen] = useState(false);

  // const [chooseCoupons, setChooseCoupons] = useState([]);
  // const [itemChooseCoupon, setItemChooseCoupon] = useState([]);
  // const [storesChooseItemShowData, setStoresChooseItemShowData] = useState([]);

  // 存数据
  const saveCouponData = () => {
    setIsSave(true);
    // setStoresChooseItemShowIdData(num);
    // setShowItemCouponData(chooseCoupons);
    // setShowItemCouponData([...chooseCoupons,...itemCoupons]);
    // setCoupons(allItemCoupons);
    if (couponList?.length > 0) {
      tableRef.current.type === 'dataTableSubmit' &&
        tableRef.current.onSubmit();
    } else {
      setDialogStatus(false);
    }
    setCoupons(couponList);
    dispatch({
      type: 'sceneMarketing/saveCouponsId',
      payload: {
        value: couponId,
      },
    });
    // 存每条coupons
    dispatch({
      type: 'sceneMarketing/saveItemCoupons',
      payload: {
        value: {
          id: couponId,
          coupons: couponList,
        },
      },
    });
    setModify({});
    // 存已选couopns
    dispatch({
      type: 'sceneMarketing/saveCouponsList',
      payload: {
        value: couponList,
      },
    });
    // setChooseCoupons([]);
  };

  // 触发校验后调用
  const validateSubmit = (dataArr, type) => {
    // dataArr是数据列表，type是错误类型，formData是更改后的值
    // console.log(dataArr, type, formData, 'formData');
    if (type === 'success') {
      onCloseDialog();
      setDialogStatus(false);
    }
  };

  // useMemo(() => {
  //   // 取数据，匹配数据
  //   if (itemCoupons) {
  //   }
  // }, [couponType, couponId]);

  // 点击打开添加优惠券列表弹窗
  const handleAddCouponList = () => {
    setCouponOpen(true);
  };
  const storesContent = () => {
    return (
      <>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '28px',
            marginBottom: '-18px',
          }}
        ></div>
        <Box>
          <DataTableNativeML
            control={control}
            // paging={false}
            pageButton={false}
            columns={columns}
            columnKey="id"
            data={couponList}
            // total={total}
            devicesMinWidth="auto"
            // chooseIds={storesChooseItemShowIdData}
            chooseData={couponList}
            tableRef={tableRef}
            validateSubmit={validateSubmit}
            rowEdit={true}
          />
        </Box>
        {/* 点击添加弹出弹窗 */}
        <Fab
          style={{ marginLeft: '32px' }}
          color="primary"
          aria-label="add"
          onClick={() => handleAddCouponList()}
          size={'medium'}
        >
          <AddIcon style={{ color: '#fff' }}></AddIcon>
        </Fab>
      </>
    );
  };

  // 设置赠券数
  const handleSetCouponCode = () => {
    // let newArr = [...allItemCoupons];
    // allItemCoupons.filter((item) => item.id === id)[0]['couponCode'] = couponCode;
    // setChooseCoupons(newArr);
  };

  //点击删除已经选中的商品
  const handleDeleteProducts = (id) => {
    // allItemCoupons 里删除
    const newArr = [...couponList];
    // const deleteCoupons= newArr.filter((item)=>item.id!==id);
    // console.log(newArr.findIndex((item)=>item.id===id),'删除的id');
    let deleteIndex = newArr.findIndex((item) => item.id === id);

    newArr.splice(deleteIndex, 1);
    // console.log(newArr,'newArr');
    dispatch({
      type: 'sceneMarketing/saveCouponsList',
      payload: {
        value: newArr,
      },
    });
    dispatch({
      type: 'sceneMarketing/saveItemCoupons',
      payload: {
        value: {
          id: couponId,
          coupons: newArr,
        },
      },
    });
  };

  const columns = [
    {
      // title: '优惠券名称',
      title: formatMessage({ id: 'marketing.scene.holiday.d01.lbl03' }),
      align: 'center',
      id: 'title',
      key: 'title',
      width: 120,
    },
    {
      // title: '适用商品',
      title: formatMessage({ id: 'marketing.scene.holiday.d01.lbl04' }),
      id: 'isAllGoods',
      width: 100,
      align: 'center',
      key: 'isAllGoods',
      render: ({ isAllGoods }) => {
        switch (isAllGoods) {
          case 0:
            return '指定适用商品';
          case 1:
            return '所有商品';
          case 2:
            return '不适用商品';
          default:
            return '';
        }
      },
    },
    {
      // title: '优惠内容',
      title: formatMessage({ id: 'marketing.scene.holiday.d01.lbl05' }),
      align: 'center',
      id: 'subTitle',
      key: 'subTitle',
      width: 95,
    },
    {
      // title: '领取人限制',
      title: formatMessage({ id: 'marketing.scene.holiday.d01.lbl06' }),
      align: 'center',
      id: 'memberLimit',
      key: 'memberLimit',
      width: 115,
      render: ({ memberLimit }) => {
        return <div>{memberLimit ? '不限' : '会员'}</div>;
      },
    },
    {
      // title: '限领次数',
      title: formatMessage({ id: 'marketing.scene.holiday.d01.lbl07' }),
      align: 'center',
      id: 'isLimitMaxCoupons',
      key: 'isLimitMaxCoupons',
      width: 95,
      render: ({ isLimitMaxCoupons }) => {
        return <div>{!isLimitMaxCoupons ? '不限' : '限制'}</div>;
      },
    },
    {
      // title: '剩余库存',
      title: formatMessage({ id: 'marketing.scene.holiday.d01.lbl08' }),
      align: 'center',
      id: 'surplus',
      key: 'surplus',
      width: 95,
    },
    {
      // title: '赠券数',
      title: formatMessage({ id: 'marketing.people.regnotcon.c02.lbl04' }),
      type: 'input',
      align: 'center',
      id: 'couponCode',
      key: 'couponCode',
      event: {
        onChange: (id, couponCode) => {
          handleSetCouponCode(id, couponCode);
        },
      },
      width: 120,
    },
    {
      // title: '操作',
      title: formatMessage({ id: 'marketing.people.regnotcon.c02.lbl05' }),
      align: 'center',
      id: 'details',
      width: 100,
      render: (items) => {
        return (
          <div
            style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              lineHeight: '64px',
            }}
          >
            <div
              style={{
                display: 'flex',
                lineHeight: '64px',
                cursor: 'pointer',
              }}
            >
              <ButtonTip title="删除">
                <IconButton>
                  <DeleteForeverOutlinedIcon
                    style={{
                      fontSize: '20px',
                      color: '#525CA3',
                    }}
                    // onClick={() => {
                    //   opt !== 'detail' && handleDeleteProducts(items.id);
                    // }}
                    onClick={() => {
                      handleDeleteProducts(items.id);
                    }}
                  ></DeleteForeverOutlinedIcon>
                </IconButton>
              </ButtonTip>
            </div>
          </div>
        );
      },
    },
  ];

  // 关闭优惠券列表弹窗
  const onCloseDialog = (data) => {
    if (data) {
      // 存储输入框里的值
      saveCouponData();
    } else {
      setDialogStatus(false);
    }
  };

  return (
    <CouponModalStyled theme={theme}>
      <DialogML
        open={dialogStatus}
        title={labelCom}
        minheightinit={480}
        minwidthinit={930}
        describe={storesContent()}
        handleClose={onCloseDialog}
        specilaAlgorithmLabValue={'ok'}
      />
      {/* 新建时弹出框 */}
      {/* 选中的数据需要回传 */}
      <ChooseCoupon
        // couponType={type}
        dialogStatus={couponOpen}
        setDialogStatus={setCouponOpen}
        // coupons={coupons}
        setCoupons={setCoupons}
        // setItemChooseCoupon={setItemChooseCoupon}
        // 每条数据的唯一标志
        couponId={couponId}
        // allItemCoupons={allItemCoupons}
        // ids={ids}
        // editId={id}
      ></ChooseCoupon>
    </CouponModalStyled>
  );
};
